import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TraceClassDecorator } from '@sentry/angular';
import { MessageService, SelectItem } from 'primeng';
import {
  AppVersion,
  deleteVersion,
  mobileversionModel,
  platform
} from '../../../../../models/AppVersion';
import {
  PromiseResult,
  ErrorModel,
  ServerError
} from '../../../../../models/PromiseResult';
import { PaginationModel } from '../../../../../models/util.models';
import { AppVersionService } from '../../../../../services/admin/app_version.service';
import { DoctorBreadcrumbService } from '../../../shared/breadcrumb.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';

@TraceClassDecorator()
@Component({
  selector: 'app-app-versions',
  templateUrl: './app-versions.component.html',
  styleUrls: ['./app-versions.component.css']
})
export class AppVersionsComponent implements OnInit {
  deleteBody = new deleteVersion();
  createBody = new mobileversionModel();
  pagination = new PaginationModel();
  response = new PromiseResult();
  tableResponse = new PromiseResult();
  error = new ErrorModel();
  serverError = new ServerError();
  posting: boolean;
  createDialog: boolean = false;
  slug: string = '';
  versionList: AppVersion[] = [];
  platform_list: SelectItem[] = [
    {
      label: 'Select',
      value: null
    }
  ];
  loading = false;
  constructor(
    private readonly appVersion: AppVersionService,
    private readonly titleService: Title,
    private readonly messageService: MessageService,
    private readonly breadCrumb: DoctorBreadcrumbService,
    private readonly providerstateService: ProviderStateService
  ) {
    this.posting = false;
    this.pagination = {
      page_no: 1,
      records_per_page: 10
    };
    Object.values(platform).forEach((ele) => {
      this.platform_list.push({
        value: ele,
        label: ele
      });
    });
    this.breadCrumb.setItems([
      { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`] },
      { label: 'Admin' },
      { label: 'App Versions' }
    ]);
  }

  async ngOnInit(): Promise<void> {
    this.titleService.setTitle('Dashboard - App Versions');
    this.slug = this.providerstateService.getProviderSlug();
    await this.fetchVersions();
  }

  async fetchVersions(): Promise<void> {
    this.ResetResultModels();
    this.posting = true;
    await this.appVersion
      .fetchAll(this.pagination)
      .toPromise()
      .then((result) => {
        this.versionList = [];
        this.tableResponse = result;
        if (result.success) {
          this.versionList = result.data.data;
        }
      })
      .catch((error: HttpErrorResponse) => {
        this.serverError = error.error;
        this.tableResponse.success = false;
      });
    this.posting = false;
  }

  private ResetResultModels(): void {
    this.response = new PromiseResult();
    this.serverError = new ServerError();
    this.tableResponse = new PromiseResult();
  }

  async create(): Promise<void> {
    this.ResetResultModels();
    this.loading = true;
    await this.appVersion
      .create(this.createBody)
      .toPromise()
      .then(async (result) => {
        this.response = result;
        if (result.success) {
          this.createDialogFn(false);
          this.messageService.add({
            severity: 'success',
            summary: 'Created',
            detail: 'This App Version has been Created!'
          });
          await this.fetchVersions();
        }
      })
      .catch((error: HttpErrorResponse) => {
        this.serverError = error.error;
        this.response.success = false;
      });
    this.loading = false;
  }

  async delete(app_guid: string): Promise<void> {
    this.deleteBody.app_guid.push(app_guid);
    this.ResetResultModels();
    this.posting = true;
    await this.appVersion
      .delete(this.deleteBody)
      .toPromise()
      .then(async (result) => {
        this.response = result;
        if (result.success) {
          this.messageService.add({
            severity: 'info',
            summary: 'Deleted',
            detail: 'This App Version has been deleted!'
          });
          await this.fetchVersions();
        }
      })
      .catch((error: HttpErrorResponse) => {
        this.serverError = error.error;
        this.response.success = false;
      });
    this.posting = false;
    this.deleteBody.app_guid = [];
  }

  createDialogFn(val: boolean): void {
    this.response = new PromiseResult();
    this.createBody = new mobileversionModel();
    this.createDialog = val;
  }

  async nextPage(): Promise<void> {
    if (this.versionList.length > 0) {
      this.pagination.page_no++;
      await this.fetchVersions();
    }
  }

  async prevPage(): Promise<void> {
    if (this.pagination.page_no > 1) {
      this.pagination.page_no--;
      await this.fetchVersions();
    }
  }
}
